import React from 'react';
import { Container, Divider,Grid } from '@mui/material';
import styled from 'styled-components';
import a1 from '../../Assets/api1.jpg';
import a2 from '../../Assets/api2.jpg';
import a3 from '../../Assets/api3.png';
import a4 from '../../Assets/api4.jpg';

// const SectionWhite = styled.section`
//   padding: 0;
// `;

const TeamInfo = styled.div`
  display: block;
  margin-bottom: 0;

  p {
    color: #acacac;
    font-style: italic;
  }

  &::after {
    display: inline-block;
    vertical-align: middle;
    content: '';
    width: 50px;
    height: 3px;
  }
`;

const TeamItem = styled.div`
  text-align: justify;
  margin: 20px;
  padding: 50px 30px 50px 30px;
  border-radius: 8px;
  transition: all 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    background: #66023c;
    color: white;
  }

  h3 {
    margin: 20px 0 1px 0 !important;
    color: rgb(100, 76, 76);
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    transition: all 0.25s ease-in-out;
  }

  &:hover h3 {
    color: #ddd;
  }
`;

const TeamImg = styled.img`
  max-width: 300px;
  padding: 6px 6px;
  border-radius: 5%;
  display: block;
  margin: auto;
`;

const TeamRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch; /* Ensure all items stretch to the same height */
  gap: 20px; /* Optional: adds space between items */
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
const TeamInfoContainer = styled.div`
  text-align: justify;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

function AboutUs() {
  const message = `at the forefront of API management and integration. Founded on the principles of reliability, efficiency, and innovation, we are committed to providing businesses with the tools they need to ensure seamless API operations and integration. Our focus is on helping you streamline API management, enhance performance, and drive growth.`;
  const teammessage = `Behind every line of code, every innovative feature, and every satisfied customer is a dedicated team committed to excellence. Our engineers, data scientists, and support staff work tirelessly to ensure that Tylect remains at the forefront of sapi hub technology. We're not just experts in our field; we're passionate individuals driven by a shared vision: to redefine server monitoring for the modern age.`;
  return (
    <>
      <Grid py={6} px={2}>
        <Container>
          <div className="row">
            <TeamInfoContainer className="col-md-12 mx-auto">
              <h2 className="section-title">Who We Are</h2>
              <p className="section-subtitle">
                <span>'Welcome to InnoWave API Hub' – </span>
                {message}
              </p>
            </TeamInfoContainer>
            <TeamRow>
              <TeamItem>
                <TeamImg
                  src={a1}
                  className="team-img"
                  alt="Comprehensive API Documentation"
                  width="300px"
                  height="auto"
                  loading="lazy"
                  title="API Documentation"
                />
                <h3>ADVANCED API DOCUMENTATION</h3>
                <TeamInfo>{/* <p>Head of SEO</p> */}</TeamInfo>
                <p>
                  Explore in-depth API documentation, from integration guides to endpoint details and beyond. Our
                  platform provides clear, concise, and up-to-date resources, making it easier for developers to
                  seamlessly integrate and utilize your APIs. With real-time updates and comprehensive examples, we
                  ensure you have the information you need, when you need it.
                </p>
              </TeamItem>

              <TeamItem>
                <TeamImg
                  src={a2}
                  className="team-img"
                  width="300px"
                  alt="User-Friendly Dashboard"
                  height="auto"
                  loading="lazy"
                  title="User-Friendly Dashboard"
                />
                <h3>User-Friendly Dashboard</h3>
                <TeamInfo>{/* <p>Marketing Manager</p> */}</TeamInfo>
                <p>
                  We believe in simplicity and usability. Our dashboard is designed with the developer in mind,
                  providing an intuitive interface that allows you to easily navigate through comprehensive API
                  documentation, access integration resources, and manage your API usage with ease. With a clean,
                  streamlined design, you can quickly find the information and enhance your development process
                  effortlessly.
                </p>
              </TeamItem>

              <TeamItem>
                <TeamImg
                  src={a3}
                  className="team-img"
                  width="300px"
                  alt="Customizable Solutions"
                  height="auto"
                  loading="lazy"
                  title="Customizable Solutions"
                />
                <h3>Customizable Solutions</h3>
                <TeamInfo>{/* <p>SEO Specialist</p> */}</TeamInfo>
                <p>
                  We understand that every business has unique needs, which is why we offer customizable solutions
                  through InnoWave API Hub. Whether you're a small business or a large enterprise, our platform adapts
                  to your requirements, allowing you to tailor the API documentation and integration resources to fit
                  your specific workflows and use cases. Ensuring a seamless experience at every stage.
                </p>
              </TeamItem>

              <TeamItem>
                <TeamImg
                  src={a4}
                  className="team-img"
                  width="300px"
                  alt="Security First"
                  height="auto"
                  loading="lazy"
                  title="Security First"
                />
                <h3>Security First</h3>
                <TeamInfo>{/* <p>SEO Specialist</p> */}</TeamInfo>
                <p>
                  In a world where digital security is paramount, we prioritize the protection of your API integrations
                  and data. With advanced encryption protocols and stringent access controls, we ensure that your
                  sensitive information is secure. You can trust InnoWave API Hub to keep your data safe, allowing you
                  to focus on seamless API integration and development with peace of mind.
                </p>
              </TeamItem>
            </TeamRow>
          </div>
        </Container>
      </Grid>
      <Divider />
      <Grid py={6} px={2}>
        <Container>
          <div className="row">
            <TeamRow>
              <TeamItem>
                <h2 className="section-title">OUR TEAM</h2>
                <p className="section-subtitle">{teammessage}</p>
              </TeamItem>
              <TeamItem>
                <h2 className="section-title">Join Us on This Journey</h2>
                <p className="section-subtitle">{teammessage}</p>
              </TeamItem>
            </TeamRow>
          </div>
        </Container>
      </Grid>
    </>
  );
}

export default AboutUs;
